/** Authorization header for calls to protected server routes (current Supabase session). */
export const getBearerHeaders = async (): Promise<Record<string, string>> => {
  try {
    const supabase = useSupabaseClient()
    const { data: { session } } = await supabase.auth.getSession()
    return session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}
  } catch {
    return {}
  }
}
